import { Text } from 'foundations-components/components/Text';
import MdxHeader from './MdxHeader';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledH4 = props => /*#__PURE__*/_jsx(Text, Object.assign({}, props, {
  as: "h4"
}));
function MdxH4(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/_jsx(MdxHeader, {
    Component: StyledH4,
    marginBlockStart: "0",
    marginBlockEnd: "800",
    children: children
  });
}
export default MdxH4;